import React from 'react'
import { Icon } from '@mobi/component-library/Common/Icon'
import { BetCard } from '@mobi/betslip/Components/Common/BetCard'
import type { BetLoopKambiShareCoupon } from '@core/Areas/BetLoop/types'
import { formatKambiCurrencyToDollarDecimal } from '@core/Areas/KambiSports/helpers/currencyFormat'
import { getEventLink } from '@core/Areas/KambiSports/helpers/navigation'
import { CountdownStatus } from '../Common/CountdownStatus'

export const Single: React.FC<{
  historyCoupon: BetLoopKambiShareCoupon
}> = ({ historyCoupon }) => {
  const meetingName = historyCoupon.events[0]?.eventName || 'Unknown Meeting'
  const eventId = historyCoupon.events[0]?.eventId
  const heading = historyCoupon.outcomes[0].label
  const subHeading = historyCoupon.betOffers[0].criterion
  const priceWin = historyCoupon.bets[0].betOdds

  return (
    <>
      <BetCard.EventDetails
        iconComponent={<Icon size='1.6rem' type='tab' />}
        heading={meetingName}
        statusComponent={
          <CountdownStatus
            eventStartTimes={historyCoupon.events[0].eventStartDate}
            betStatus={historyCoupon.bets[0].betStatus}
          />
        }
      />
      <BetCard.SelectionInfo
        iconComponent={<Icon size='1.6rem' type='tab' />}
        heading={heading}
        subHeading={subHeading}
        priceWin={formatKambiCurrencyToDollarDecimal(priceWin)}
        linkInfo={{
          pathname: getEventLink(eventId),
        }}
      />
    </>
  )
}
